import { Capacitor } from '@capacitor/core';

import { APIAuthenticatedService } from './APICallsAuthenticated';
import { getUnreadReferralCount } from './referralUnread';
import { ReferralBadge } from '../plugins/referralBadge';

export const isAndroidReferralBadgeAvailable = () =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android';

export const setAndroidReferralBadgeCount = async (count: number) => {
  if (!isAndroidReferralBadgeAvailable()) {
    return;
  }

  try {
    if (count <= 0) {
      await ReferralBadge.clear();
      console.log('[push] cleared Android badge count');
      return;
    }

    await ReferralBadge.setCount({ count });
    // REQ-049: avoid logging unread counts derived from notification or referral data.
    console.log('[push] updated Android badge count');
  } catch (error) {
    // REQ-049: avoid logging raw native badge errors that may include notification context.
    console.log('[push] failed to update Android badge count');
  }
};

export const syncAndroidReferralBadgeCountFromApi = async (
  apiService: Pick<APIAuthenticatedService, 'getUserReferralsIn' | 'getUserReferralsOut'>
) => {
  if (!isAndroidReferralBadgeAvailable()) {
    return;
  }

  try {
    const [inboundReferrals, outboundReferrals] = await Promise.all([
      apiService.getUserReferralsIn(),
      apiService.getUserReferralsOut(),
    ]);

    const unreadCount = getUnreadReferralCount({
      inboundReferrals,
      outboundReferrals,
    });

    await setAndroidReferralBadgeCount(unreadCount);
  } catch (error) {
    // REQ-049: avoid logging raw API errors from badge sync paths.
    console.log('[push] failed to sync Android badge count from API');
  }
};
